import { Chain, Transport, http } from 'viem';

type ExtractRpcUrlsParameters = {
  transports?: Record<string, Transport> | undefined;
  chain: Chain;
};

export function extractRpcUrls({ chain }: ExtractRpcUrlsParameters) {
  const fallbackUrl = chain.rpcUrls.default.http[0];
  const transport = http()({ chain });

  return [transport].map(({ value }) => value?.url ?? fallbackUrl);
}
